<template>
  <v-dialog v-model="show" max-width="500" persistent>
    <v-card>
      <v-card-title class="text--secondary">
        <v-icon class="mr-2">mdi-alert-circle-outline</v-icon>
        Feature Currently Disabled
      </v-card-title>
      <v-card-text class="text--primary pt-4">
        <p>
          This feature is currently disabled due to process changes at the Schaeffler IT Security Department.
        </p>
        <p class="mb-0">
          Azure Permissions must be requested via email at 
          <a class="link" :href="mailtoLink" target="_blank">
            OR-HZA-AccessMgmt@schaeffler.com
          </a>
        </p>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="#006c27" class="white--text" @click="close">
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "AzurePermissionDisabledDialog",
  props: {
    value: Boolean,
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    mailtoLink() {
      const email = "OR-HZA-AccessMgmt@schaeffler.com";
      const subject = "ADMIN CONSENT REQUEST";
      const body = `Email Title: ADMIN CONSENT REQUEST "[Application Name]"

1. Application Information:
Application Name: [Your Application Name / Name or Client ID of the App Registration / Managed Identity]
Project/Product Overview: Brief description of the project/product, including purpose and key functionalities.

2. API Permission Request:
API Permission Name: [Name of the API Permission]
Permission Type: [Delegated/Application]
Permissions Required details: Detailed information why this permission is required for application with strong technical justification. If Application permission type was selected please provide information why Delegated permission can't be used. If permission is tenant wide, please provide information if it can be limited to specific groups, users or resources.
If more then one permission is required please provide details for each of them.

3. Security by design:
Security by Design Approval: Include links or references to relevant IT Security by design approvals related to your application.

4. Security Measures:
Data Sensitivity: Specify the type of data handled and its sensitivity (based on IT Security by design).
Password Storage Practices: Outline how you store and protect application secrets.
Did you consider usage of Service Account or Managed Identities instead of Application secrets? https://learn.microsoft.com/en-us/entra/identity/managed-identities-azure-resources/overview`;

      return `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    },
  },
  methods: {
    close() {
      this.$emit("input", false);
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
a.link {
  color: #006c27;
  background-color: transparent;
  text-decoration: none;
  cursor: pointer !important;
}
</style>
